module.exports = __webpack_public_path__ + "img/Motor_mob_1.53cc9041.jpg";